import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import { Utils } from '@singularsystems/neo-core';
var FormGroupLayoutContextParams = /** @class */ (function () {
    function FormGroupLayoutContextParams() {
    }
    return FormGroupLayoutContextParams;
}());
export { FormGroupLayoutContextParams };
export var FormGroupLayoutContext = React.createContext(new FormGroupLayoutContextParams());
var GridLayout = /** @class */ (function (_super) {
    __extends(GridLayout, _super);
    function GridLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridLayout.prototype.render = function () {
        var _a = this.props, gutterSize = _a.gutterSize, verticalSpace = _a.verticalSpace, withGaps = _a.withGaps, alignItems = _a.alignItems, formGroupProps = _a.formGroupProps, xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, xxl = _a.xxl, domProps = __rest(_a, ["gutterSize", "verticalSpace", "withGaps", "alignItems", "formGroupProps", "xs", "sm", "md", "lg", "xl", "xxl"]);
        var columnClassName = Utils.joinWithSpaces(gutterSize && "px-" + gutterSize, xs && "col-" + 12 / xs, sm && "col-sm-" + 12 / sm, md && "col-md-" + 12 / md, lg && "col-lg-" + 12 / lg, xl && "col-xl-" + 12 / xl, xxl && "col-xxl-" + 12 / xxl);
        if (!(xs || sm || md || lg || xl || xxl)) {
            columnClassName = Utils.joinWithSpaces(columnClassName, "col-md-6");
        }
        var rowClassName = Utils.joinWithSpaces(domProps.className, "row", gutterSize && "mx-n" + this.props.gutterSize, alignItems && "align-items-" + this.props.alignItems);
        var containerStyle = domProps.style;
        var columnStyle = undefined;
        if (withGaps && !verticalSpace) {
            verticalSpace = "1rem";
        }
        if (verticalSpace) {
            containerStyle = containerStyle || {};
            containerStyle.marginTop = "-" + verticalSpace;
            columnStyle = { marginTop: verticalSpace };
        }
        return (React.createElement(FormGroupLayoutContext.Provider, { value: { formGroupProps: this.props.formGroupProps } },
            React.createElement("div", __assign({}, domProps, { className: rowClassName, style: containerStyle }), React.Children.map(this.props.children, function (child) { return (child && React.createElement("div", { className: columnClassName, style: columnStyle }, child)); }))));
    };
    return GridLayout;
}(React.Component));
export default GridLayout;
